<template>

    <div class="chat-wrapper">

        <div class="chat-body">

            <div v-for="(msg, index) in chatHistory" :key="index" class="chat-message" :class="msg.from">
                <div class="user-info">
                    <img v-if="msg.from === 'me'" src="@/assets/img/chatbot/user-icon.svg" alt="User" />
                    <img v-else src="@/assets/img/chatbot/message.svg" alt="Bot" />
                </div>

                <div class="message-content">
                    <div v-if="msg.type === 'file'">
                        <div class="file-message">
                            <img :src="msg.icon" class="file-icon" alt="file icon" />
                            <div class="file-details">
                                <span>{{ msg.name }}</span>
                            </div>
                            <img src="@/assets/img/chatbot/download.svg" class="download-icon" alt="download file" />
                        </div>
                        <p>{{ msg.text }}</p>
                    </div>

                    <div v-else-if="msg.type === 'text'" class="message-text" :class="{ typing: msg.thinking }">
                        {{ msg.text }}
                    </div>

                    <div v-else-if="msg.type === 'html'" class="message-text" :class="{ typing: msg.thinking }"
                        v-html="formatText(msg.text)"></div>
                </div>
            </div>
        </div>

        <div class="fab-menu" v-if="showMenu">
            <div v-for="item in menuItems" :key="item.name" class="fab-menu-item" @click="handleMenuClick(item.name)">
                <img :src="item.icon" :alt="item.label" />
                <span>{{ item.label }}</span>
            </div>
        </div>

        <div class="chat-input-container">
            <div class="chat-input">
                <img class="fab-toggle" @click="showMenu = !showMenu" src="@/assets/img/chatbot/chat/puzzle.svg"
                    v-if="$route.path === '/chat'" alt="menu" />

                <img v-if="type == 'file'" class="upload-icon" src="@/assets/img/chatbot/upload.svg" alt="upload"
                    @click="triggerFileUpload" />
                <input v-if="type == 'file'" ref="fileInput" type="file" accept="application/pdf" style="display: none"
                    @change="handleFileUpload" />

                <input v-if="type !== 'faq'" :value="localMessage" @input="onInput" type="text"
                    placeholder="Dinos algo..." @keyup.enter="trySend" />

                <button v-if="type !== 'faq' && (!isThinking || (type === 'file' && localPdfUrl))"
                    :disabled="isThinking" @click="trySend">
                    <span>Enviar</span>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: "ChatBox",
    computed: {
        ...mapGetters(['chatHistory', 'newMessage', 'chatType', 'localPdfUrl', 'dbKey']),
        localMessage: {
            get() {
                return this.newMessage;
            },
            set(val) {
                this.updateMessage(val);
            }
        },
        type() {
            return this.chatType;
        },
        isThinking() {
            return this.chatHistory.some(msg => msg.thinking);
        }
    },
    data() {
        return {
            showMenu: false,
            menuItems: [
                { name: "file", icon: require('@/assets/img/chatbot/chat/chat.svg'), label: "Sube Documentos" },
                { name: "db", icon: require('@/assets/img/chatbot/chat/db.svg'), label: "Analiza tus Datos" },
                { name: "faq", icon: require('@/assets/img/chatbot/chat/faq.svg'), label: "Habla IA" },
                { name: "new", icon: require('@/assets/img/chatbot/chat/new.svg'), label: "Nuevo Chat" },
            ]
        }
    },
    methods: {
        ...mapActions(['updateMessage', 'addMessage', 'resetChat', 'changeChatType']),

        handleMenuClick(type) {
            this.updateMessage('');
            this.showMenu = false;
            if (type === 'new') {
                this.resetChat();
                this.changeChatType('file');
            } else {
                this.changeChatType(type);
            }
        },
        onInput(e) {
            this.localMessage = e.target.value;
        },
        trySend() {
            const trimmed = this.localMessage.trim();
            if (this.isThinking) {
                return;
            }

            if (this.type === 'db') {
                if (!this.dbKey || !trimmed) return;
            } else if (this.type === 'file') {
                if (!this.localPdfUrl || !trimmed) return;
            } else {
                if (!trimmed) return;
            }

            this.$emit('send', trimmed);
        },

        triggerFileUpload() {
            this.$refs.fileInput.click();
        },
        formatText(text) {
            return text ? text.replace(/\n/g, '<br>') : '';
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file || file.type !== "application/pdf") {
                alert("Solo se permiten archivos PDF.");
                return;
            }
            this.$emit("file-uploaded", file);
        }
    }
};
</script>


<style scoped>
.fab-toggle {
    display: none;
}

.chat-wrapper {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
}


.db-buttons button {
    padding: 10px 7rem;
    border: 1px solid #7a94b2;
    background: transparent;
    color: #7a94b2;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
}

.db-buttons button:hover {
    border-color: white;
    color: white;
}

.db-buttons button.active {
    border-color: #ffffff;
    color: #ffffff;
}

.chat-body {
    flex: 1;
    padding: 10px 30px;
    overflow-y: auto;
    background-color: #061821;
}

.chat-message {
    display: flex;
    text-align: start;
    align-items: start;
    margin-bottom: 10px;
    background-color: #071E29;
    padding: 15px 10px;
    border-radius: 5%;
}

.chat-message.bot .user-info img {
    border-radius: 50%;
    padding: 6px;
    margin-top: 4px;
    width: 40px;
    height: 40px;
}

.chat-message.bot {
    background-color: #202124;
}

.chat-message .message-content {
    display: flex;
    flex-direction: column;
    max-width: auto;
    margin: 0 8px;
    font-size: 12px;
}

.message-text {
    color: white;
    padding: 10px 14px;
    border-radius: 8px;
}

.message-text.typing::after {
    content: "...";
    display: inline-block;
    animation: blink 1s steps(1) infinite;
}

@keyframes blink {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.2;
    }
}

.file-message {
    display: flex;
    align-items: center;
    background-color: #1e3342;
    color: white;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 12px;
}

.file-icon,
.download-icon {
    width: 28px;
    height: 28px;
    object-fit: contain;
}

.file-details {
    flex: 1;
    font-size: 12px;
}

.chat-input-container {
    background-color: #17181B;
    padding: 10px 6px;
    height: 90px;
    flex-shrink: 0;
}

.chat-input {
    display: flex;
    align-items: center;
    background-color: #202124;
    border-radius: 16px;
    padding: 10px 0% 10px 10px;
    gap: 12px;
    margin: 4px
}

.chat-input input {
    flex: 1;
    background: transparent;
    border: none;
    color: #ffffff;
    font-size: 16px;
    outline: none;
}

.chat-input input::placeholder {
    color: #a0a0a0;
}

.chat-input img {
    width: 40px;
    height: 40px;
}

.chat-input button {
    display: flex;
    align-items: center;
    gap: 10px;
    background: none;
    border: none;
    color: #47A4D0;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    padding-right: 20px;
}

.chat-input select {
    background-color: #202124;
    color: #ffffff;
    border: none;
    border-radius: 12px;
    padding: 8px 12px;
    font-size: 16px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    outline: none;
}

.chat-input select option {
    background-color: #202124;
    color: #ffffff;
}

.mic {
    width: 25px !important;
    height: 25px !important;
}

@media (max-width: 768px) {
    .chat-box {
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .chat-body {
        height: calc(75vh - 150px);
        padding: 10px 16px;
    }

    .fab-toggle {
        display: block;
    }

    .chat-input-container {
        background-color: #17181B;
        padding: 10px 4px;
        height: 90px;
    }

    .fab-menu-toggle {
        width: 48px;
        height: 48px;
        background-color: #2c6b94;
        border: none;
        color: white;
        font-size: 28px;
        border-radius: 50%;
        z-index: 1000;
    }

    .fab-menu {
        position: absolute;
        bottom: 80px;
        left: 15px;
        padding: 10px;
        z-index: 1000;
        animation: slideUp 0.3s ease-out;

    }

    .fab-menu-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px;
        color: white;
        cursor: pointer;
    }

    .fab-menu-item img {
        width: 24px;
        height: 24px;
    }

    .fab-menu-item:hover {
        background-color: #333;
    }

    .chat-input-container {
        background-color: #17181B;
        padding: 6px;
        height: auto;
    }

    .chat-input {
        display: flex;
        align-items: center;
        background-color: #202124;
        border-radius: 16px;
        padding: 6px 8px;
        gap: 8px;
        flex-wrap: nowrap;
    }

    .chat-input input {
        flex: 1;
        background: transparent;
        border: none;
        color: #ffffff;
        font-size: 16px;
        outline: none;
        min-width: 0;
    }

    .chat-input input::placeholder {
        color: #a0a0a0;
    }

    .chat-input button {
        background: none;
        border: none;
        color: #47A4D0;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        white-space: nowrap;
    }

    .chat-input img.fab-toggle {
        width: 30px;
        height: 30px;
        cursor: pointer;
    }

    .chat-input img.upload-icon {
        width: 30px;
        height: 30px;
        cursor: pointer;
    }

}

@keyframes slideUp {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
